import { useEffect, useState } from 'react';

export const useAccordionUpdate = (expanded: boolean = false) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(expanded);

  useEffect(() => {
    setIsExpanded(expanded);
  }, [expanded]);

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  return {
    isExpanded,
    setIsExpanded,
    toggleExpanded,
  };
};
